<template>
  <v-dialog v-model="displayForm" persistent max-width="1240px">
    <v-form ref="form" v-model="valid" lazy-validation v-if="displayForm">
      <v-card>
        <v-card-title>
          <span class="headline">Add Iron Set</span>
        </v-card-title>
        <v-card-text>
          <v-alert
            :value="msg"
            type="error"
            dismissible
            transition="scale-transition"
            v-for="msg in message"
            :key="msg"
          >{{ msg }}</v-alert>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md2>
                <v-checkbox v-model="model.sst" label="SST Pure" :false-value="0" :true-value="1"></v-checkbox>
              </v-flex>
              <v-flex xs12 md2>
                <v-checkbox
                  v-model="model.headOnly"
                  label="Head Only"
                  :false-value="0"
                  :true-value="1"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md2>
                <v-checkbox
                  v-model="model.stamping"
                  label="Stamping"
                  :false-value="0"
                  :true-value="1"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md2>
                <v-checkbox
                  v-model="model.paintfill"
                  label="Paintfill"
                  :false-value="0"
                  :true-value="1"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field v-model="model.quantity" label="Quantity" :rules="mandatoryRules"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex v-for="(detail, ironType) in ironTypeList" :key="ironType">
                    <v-checkbox
                      v-model="model.ironTypes"
                      :label="ironType"
                      :value="ironType"
                      :disabled="detail.disabled"
                      :color="detail.color"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md6>
                <set-autocomplete
                  :filters="{
                    dominantHand: this.dominantHand,
                    classification: 'iron,utility iron,adaptor tips',
                    catalogId: this.catalogId
                  }"
                  label="Set Head"
                  :rules="mandatoryRules"
                  v-model="model.headProductId"
                ></set-autocomplete>
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field
                  label="Loft"
                  v-model="model.headLoft"
                  :rules="[rules.notHeadOnlyRequired]"
                  :disabled="!model.headProductId"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field
                  v-model="model.headLie"
                  :rules="[rules.notHeadOnlyRequired]"
                  label="Lie"
                  :disabled="!model.headProductId"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field
                  v-model="model.headStamp"
                  label="Stamp"
                  :disabled="!model.headProductId"
                ></v-text-field>
              </v-flex>
              <template v-if="!model.headOnly">
                <v-flex xs12 md6>
                  <set-autocomplete
                    :filters="{
                      classification:
                        'iron shaft, hybrid shaft, flexible iron shaft',
                      catalogId: this.catalogId
                    }"
                    label="Set Shaft"
                    :rules="[rules.notHeadOnlyRequired]"
                    v-model="model.shaftProductId"
                  ></set-autocomplete>
                  <v-select
                    v-if="flex.length > 0"
                    :items="flex"
                    label="Flex for 6i"
                    v-model="model.shaftFlex"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="model.shaftLength"
                    label="Length"
                    :rules="[rules.notHeadOnlyRequired]"
                    :disabled="!model.shaftProductId"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field
                    v-model="model.shaftCpm"
                    label="CPM"
                    :rules="[rules.notHeadOnlyRequired]"
                    :disabled="!model.shaftProductId"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field
                    v-model="model.shaftSW"
                    label="SW"
                    :rules="[rules.notHeadOnlyRequired]"
                    :disabled="!model.shaftProductId"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field
                    v-model="model.shaftPaintfill"
                    label="PaintFill"
                    :disabled="!model.shaftProductId"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <product-autocomplete
                    :filters="{
                      classification: 'grip',
                      catalogId: this.catalogId,
                    }"
                    label="Grip"
                    :rules="[rules.notHeadOnlyRequired]"
                    v-model="model.gripProductId"
                  ></product-autocomplete>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="model.gripExtraWraps"
                    label="Extra Wraps"
                    :disabled="!model.gripProductId"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-select
                    :items="logo"
                    label="Logo"
                    v-model="model.gripLogo"
                    :disabled="!model.gripProductId"
                  ></v-select>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel()">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="add()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ProductAutocomplete from "@components/forms/autocomplete/Product.vue";
import SetAutocomplete from "@components/forms/autocomplete/IronSet.vue";
import { mapActions } from "vuex";
function getDefaultData() {
  return {
    loading: false,
    model: {
      sst: 0,
      stamping: 0,
      paintfill: 0,
      quantity: 1,
      headProductId: null,
      headLoft: null,
      headLie: null,
      headStamp: null,
      shaftProductId: null,
      shaftFlex: null,
      shaftLength: null,
      shaftCpm: null,
      shaftSW: null,
      shaftPaintfill: null,
      gripProductId: null,
      gripExtraWraps: null,
      gripLogo: null,
      ironTypes: []
    },
    logo: [
      { text: "UP", value: "up" },
      { text: "DOWN", value: "dw" }
    ],
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    valid: null,
    message: null,
    ironTypeList: {},
    flex: []
  };
}

export default {
  components: {
    ProductAutocomplete,
    SetAutocomplete
  },
  props: {
    item: {
      type: Object
    },
    open: {},
    prescriptionId: {},
    dominantHand: {},
    shopId: {},
    catalogId : {},
    type: {
      type: String,
      default: "solo"
    }
  },
  data: getDefaultData,
  computed: {
    displayForm: function() {
      return this.open;
    },
    rules: function() {
      return {
        required: value => !!value || "This field is mandatory.",
        notHeadOnlyRequired: value => {
          if (this.model.headOnly) return true;
          return !!value || "This field is mandatory.";
        }
      };
    }
  },
  methods: {
    ...mapActions('productSets', ['getIronTypes']),
    add() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("prescriptionIron/addSet", {
            id: this.prescriptionId,
            model: this.model
          })
          .then(result => {
            if (result.success) {
              this.resetForm();
              this.$emit("add");
            }
          })
          .catch(({data}) => {
            this.message = [];
            for (const [key, value] of Object.entries(data.errors)) {
              console.log(key)
                this.message.push(value[0])
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    cancel() {
      this.resetForm();
      this.$emit("cancel");
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    },
    generateIronTypeList() {
      
      this.getIronTypes({
        head:this.model.headProductId ?this.model.headProductId.id : null,
        shaft:this.model.shaftProductId ?this.model.shaftProductId.id : null,
      }).then(({ironTypes}) => {
        this.ironTypeList = ironTypes
        this.model.ironTypes = [];
      })

      if (this.model.shaftProductId && this.model.shaftProductId.tip == "FLEXIBLE") {
        this.flex = this.model.shaftProductId.particleList.split(",");
      }
      /*
      let list = [];
      this.model.ironTypes = [];
      if (this.model.headProductId && this.model.headProductId.ironTypes) {
        for (
          let index = 0;
          index < this.model.headProductId.ironTypes.length;
          index++
        ) {
          const element = this.model.headProductId.ironTypes[index];
          list.push({
            headId: element.id,
            ironTypeId: element.ironTypeId,
            disabled: true,
            color: element.stock > 0 ? "green" : "red"
          });
        }
      }
      if (this.model.shaftProductId) {
        if (
          this.model.shaftProductId.tip == "TAPER" &&
          this.model.shaftProductId.ironTypes
        ) {
          for (let index = 0; index < list.length; index++) {
            const headIronType = list[index];
            let found = false;
            for (
              let index = 0;
              index < this.model.shaftProductId.ironTypes.length;
              index++
            ) {
              const shaftIronType = this.model.shaftProductId.ironTypes[index];
              if (
                shaftIronType.ironTypeId == headIronType.ironTypeId ||
                (shaftIronType.ironTypeId == "W" &&
                  ["AW", "GW", "LW", "PW", "SW", "UW", "10I", "11I"].includes(
                    headIronType.ironTypeId
                  )) ||
                (shaftIronType.ironTypeId == "9I/W" &&
                  ["9I","AW", "GW", "LW", "PW", "SW", "UW", "10I", "11I"].includes(
                    headIronType.ironTypeId
                  ))

              )
                found = true;
            }
            headIronType.disabled = found ? false : true;
          }
        } else if (this.model.shaftProductId.tip == "PARALLEL") {
          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            element.disabled = false;
          }
        } else if (this.model.shaftProductId.tip == "FLEXIBLE") {
          this.flex = this.model.shaftProductId.particleList.split(",");
          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            element.disabled = false;
          }
        }
      } else {
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          element.disabled = true;
        }
      }
      this.ironTypeList = list;
      */
    }
  },
  watch: {
    "model.headProductId": function() {
      this.generateIronTypeList();
    },
    "model.shaftProductId": function() {
      this.generateIronTypeList();
    },
    item: function() {
      if (this.item) {
        this.model.id = this.item.id;
        this.model.headOnly = this.item.headOnly;
        this.model.sst = this.item.sst;
        this.model.paintfill = this.item.paintfill;
        this.model.stamping = this.item.stamping;
        this.model.quantity = this.item.quantity;
        this.model.headProductId = this.item.headProductId;
        this.model.headLoft = this.item.headLoft;
        this.model.headLie = this.item.headLie;
        this.model.headStamp = this.item.headStamp;
        this.model.shaftProductId = this.item.shaftProductId;
        this.model.shaftLength = this.item.shaftLength;
        this.model.shaftCpm = this.item.shaftCpm;
        this.model.shaftSW = this.item.shaftSW;
        this.model.shaftPaintfill = this.item.shaftPaintfill;
        this.model.gripProductId = this.item.gripProductId;
        this.model.gripExtraWraps = this.item.gripExtraWraps;
        this.model.gripLogo = this.item.gripLogo;
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
